import feathers from 'feathers/client';
import socketio from 'feathers-socketio/client';
import hooks from 'feathers-hooks';
import authentication from 'feathers-authentication-client';
import io from 'socket.io-client/dist/socket.io';

const socket = io('/');
const client = feathers()
  .configure(hooks())
  .configure(socketio(socket, { timeout: 45000 }))
  .configure(authentication({ storage: window.localStorage }));

export {
  client,
  socket
};
export default client;


// WEBPACK FOOTER //
// ./client/services/FeathersService.js